export default __webpack_public_path__ + "static/solana-88dd9cd2498aebe1ee8c95ce2d3b1d5c.png";